module.exports = __webpack_public_path__ + "img/imgYLSYB(10).635683ce.png";